export const getListOfGatewayName = {
  GET_LIST_OF_GATEWAY_NAME_REQUEST: "GET_LIST_OF_GATEWAY_NAME_REQUEST",
  GET_LIST_OF_GATEWAY_NAME_SUCCESS: "GET_LIST_OF_GATEWAY_NAME_SUCCESS",
  GET_LIST_OF_GATEWAY_NAME_ERROR: "GET_LIST_OF_GATEWAY_NAME_ERROR",
};

export const createGatewayName = {
  CREATE_GATEWAY_NAME_REQUEST: "CREATE_GATEWAY_NAME_REQUEST",
  CREATE_GATEWAY_NAME_SUCCESS: "CREATE_GATEWAY_NAME_SUCCESS",
  CREATE_GATEWAY_NAME_ERROR: "CREATE_GATEWAY_NAME_ERROR",
};

export const editGatewayName = {
  EDIT_GATEWAY_NAME_REQUEST: "EDIT_GATEWAY_NAME_REQUEST",
  EDIT_GATEWAY_NAME_SUCCESS: "EDIT_GATEWAY_NAME_SUCCESS",
  EDIT_GATEWAY_NAME_ERROR: "EDIT_GATEWAY_NAME_ERROR",
};

export const deleteGatewayName = {
  DELETE_GATEWAY_NAME_REQUEST: "DELETE_GATEWAY_NAME_REQUEST",
  DELETE_GATEWAY_NAME_SUCCESS: "DELETE_GATEWAY_NAME_SUCCESS",
  DELETE_GATEWAY_NAME_ERROR: "DELETE_GATEWAY_NAME_ERROR",
};
